const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

export const getExtremaMarkerOffset = () => [0, 0];

export const getGaugeLabelFontSize = ({
  gaugeWidth = 320,
  label = "",
  seriesCount = 1,
} = {}) => {
  const count = Math.max(Number(seriesCount) || 1, 1);
  const width = Math.max(Number(gaugeWidth) || 320, 160);
  const maxFontSize = count === 1 ? 32 : count <= 4 ? 24 : count <= 6 ? 20 : 17;
  const widthRatio = count === 1 ? 0.58 : count <= 4 ? 0.52 : 0.46;
  const estimatedCharacters = Math.max(`${label}`.length, 4) * 0.62;
  const fittedSize = (width * widthRatio - 20) / estimatedCharacters;

  return Math.round(clamp(fittedSize, 10, maxFontSize));
};

export const buildExtremaMarkPoint = (serie = {}, seriesIndex = 0, seriesCount = 1) => ({
  silent: true,
  symbol: "pin",
  symbolSize: 42,
  symbolOffset: getExtremaMarkerOffset(seriesIndex, seriesCount),
  itemStyle: { color: serie.color },
  label: {
    color: "#fff",
    fontSize: 9,
    lineHeight: 10,
    formatter: (params) => {
      const value = Number(params?.value);
      const unit = serie?.measure?.medida?.vc_abreviatura || "";
      return `${Number.isFinite(value) ? value.toFixed(2) : "-"}${unit.trim() ? ` ${unit}` : ""}`;
    },
  },
  data: [
    { type: "max", name: "Máximo" },
    { type: "min", name: "Mínimo" },
  ],
});

export const buildExtremaMarkLine = (serie = {}) => ({
  silent: true,
  symbol: ["none", "none"],
  label: { show: false },
  lineStyle: {
    color: serie.color,
    opacity: 0.45,
    type: "dotted",
    width: 1,
  },
  data: [
    { type: "max", name: "Máximo" },
    { type: "min", name: "Mínimo" },
  ],
});
